/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuRadioSelectSearch_itemSearch = {
    readonly displayUriRef: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuRadioSelectSearch_itemSearch";
};
export type SbSharedRefineMenuRadioSelectSearch_itemSearch$data = SbSharedRefineMenuRadioSelectSearch_itemSearch;
export type SbSharedRefineMenuRadioSelectSearch_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuRadioSelectSearch_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectSearch_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuRadioSelectSearch_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedFilterName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canBeDismissed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '1b2c24dae702a072ec8bd2c6c078a8de';
export default node;
